import secsToMinsString from '../lib/secs-to-mins-str';
import selectGameKeys from './select-game-keys';
import { selectBestScoreNumber } from './best-score';

const selectScoreCardEncryption = ({ encryption }, phrases) => {
  if (!encryption) return null;

  const { summary, headings: { latestRound } } = phrases;
  const {
    stats,
    tellLabels,
    missions,
    socialCommentary,
    ...encryptionPhrases
  } = phrases.encryption;

  // ideally these would be coming from Contentful and / or config
  const missionContent = {
    'virginia-hall': {
      alt: missions.virginiaHall.title,
      src: 'https://images.ctfassets.net/k943llvjurv1/5agrAVElcSYK05qB0RBK2p/10b90d2ca0df8689cc78c6155544343b/Encryption_Title_TheLimpingLady.png',
      averageDurationSecs: 70,
    },
    'josephine-baker': {
      alt: missions.josephineBaker.title,
      src: 'https://images.ctfassets.net/k943llvjurv1/2BDxc3dwcJFld7Wsfc5wAM/9313a46966351a4c7c4ec66a31187323/Encryption_Title_TheDaredevilDancer.png',
      averageDurationSecs: 75,
    },
  };

  const bestScore = selectBestScoreNumber(encryption.games, 'accuracy');
  const latestGame = encryption.games[0];
  const { timesPlayed } = encryption;
  const mission = missionContent[latestGame.missionKey];
  const { accuracy } = latestGame;
  const accuracyPercentage = `${Math.round(accuracy * 100)}%`;
  const missionStatus = `${latestGame.completed ? 'Successful' : 'Unsuccessful'}`;
  const duration = `${secsToMinsString(latestGame.duration)} min`;
  const { averageDurationSecs, ...missionTitleCard } = mission;
  const socialAverageDuration = secsToMinsString(averageDurationSecs);

  return {
    imageUrl: 'https://images.ctfassets.net/gtqjh9j40j4m/5x7WrsdwZatl5ENHxOmR3g/26f8a2eaf4c97ddda3330e11d6dc23ba/encryption-player.jpg',
    videoUrl: 'https://videos.ctfassets.net/gtqjh9j40j4m/7MQH8QAyN1VweZXwjpv6IC/4a095f45f211cab5dfe1fd4169de5727/encryption2.mp4',
    latestRound,
    missionTitleCard,
    summary: [
      {
        key: 'missions',
        value: timesPlayed,
        units: null,
        descriptor: summary.missionsCompleted,
      },
      {
        key: 'best-score',
        value: `${Math.round(bestScore * 100)}%`,
        units: summary.encodingAccuracy,
        descriptor: summary.bestScore,
      },
    ],
    statsMain: {
      classNames: 'stat-pair-space-between',
      stats: [
        [stats.missionStatus, missionStatus],
        [stats.timeTaken, duration],
        [stats.encodingAccuracy, accuracyPercentage],
      ],
    },
    statsWordsEncoded: {
      classNames: 'stat-single stat-caps',
      withIndex: true,
      title: stats.wordsEncoded,
      titleClass: 'title',
      stats: [
        [latestGame.encoding1.message],
        [latestGame.encoding2.message],
        [latestGame.encoding3.message],
      ],
    },
    socialCommentary: socialCommentary.replace('%A', socialAverageDuration),
    socialAverageDuration,
    ...selectGameKeys({ encryption }),
    ...encryptionPhrases,
  };
};

export default selectScoreCardEncryption;
